import { useEffect, useState } from "react";

const navItems = [
  { label: "首页", href: "#top" },
  { label: "热门排行", href: "#ranking" },
  { label: "精选合集", href: "#collections" },
  { label: "内容探索", href: "#explore" },
  { label: "创作者", href: "#creators" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "border-b border-background-200/70 bg-background-50/90 backdrop-blur-md" : "border-b border-transparent"
      }`}
    >
      <div className="flex h-16 w-full items-center justify-between gap-4 px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2 text-foreground-950">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-play-fill text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-tight">小视频</span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2 md:flex">
          <a
            href="#explore"
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-search-line text-base"></i>
            开始浏览
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </div>

      {open ? (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-md px-3 py-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#explore"
              onClick={() => setOpen(false)}
              className="mt-2 flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50"
            >
              <i className="ri-search-line text-base"></i>
              开始浏览
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}